import { StepperProvider } from "../components/stepper-provider";
import Stepper from "../components/stepper";
import NewDistributionProject from ".";
import Navbar from "@/components/top-nav";
export default function DistributionNewProjectLayout() {
  return (
    <StepperProvider>
      <Navbar />
      <Stepper />

      <NewDistributionProject />
    </StepperProvider>
  );
}
